import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';
import { signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UpdateService {
    private swUpdate = inject(SwUpdate);
    updateAvailable = signal(false);

    constructor() {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates
                .pipe(
                    filter((evt): evt is import('@angular/service-worker').VersionReadyEvent => evt.type === 'VERSION_READY'),
                    map(() => true)
                )
                .subscribe(() => {
                    this.updateAvailable.set(true);
                });
        }
    }

    async applyUpdate(): Promise<void> {
        await this.swUpdate.activateUpdate();
        document.location.reload();
    }

    checkForUpdate(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.checkForUpdate();
        }
    }
}
